import { createI18n } from 'vue-i18n';

const savedLocale = (() => {
  try {
    return localStorage.getItem('app-locale') || 'en';
  } catch {
    return 'en';
  }
})();

const messages = {};

const context = require.context('./locales', false, /\.json$/);
context.keys().forEach(key => {
  const match = key.match(/\.\/(.+)\.json$/);
  if (match) {
    messages[match[1]] = context(key);
  }
});

export default createI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
});
